import { useEffect } from 'react';

/**
 * Hält den Bildschirm an, solange die Komponente sichtbar ist.
 *
 * Im Kochmodus ist das wichtig: Man hat die Hände voll und möchte nicht, dass
 * das Gerät nach einer halben Minute in den Ruhezustand wechselt.
 */
export function useWakeLock(active: boolean): void {
  useEffect(() => {
    if (!active) {
      return;
    }
    let sentinel: WakeLockSentinel | null = null;
    let cancelled = false;

    async function request(): Promise<void> {
      try {
        if ('wakeLock' in navigator) {
          sentinel = await navigator.wakeLock.request('screen');
        }
      } catch {
        // Nicht unterstützt oder abgelehnt: kein Grund zum Abbruch.
      }
    }

    void request();

    // Wird der Tab in den Hintergrund geschoben, gibt das System die Sperre frei.
    const onVisible = () => {
      if (document.visibilityState === 'visible' && !cancelled) {
        void request();
      }
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisible);
      if (sentinel !== null) {
        void sentinel.release().catch(() => undefined);
      }
    };
  }, [active]);
}
